import {
  createFileRoute,
  useNavigate,
  useRouteContext,
} from '@tanstack/react-router';
import queryString from 'query-string';
import { useEffect } from 'react';

// relative imports
import { hasVerifiedEmailClaim } from '../../components/providers/LedgibleAuthProvider';
import LoadingPage from '../../components/shared/page-components/LoadingPage';

// Auth callback component that redirects after Auth0 callback
const AuthCallback = () => {
  const navigate = useNavigate();
  const { auth0 } = useRouteContext({ from: '/_authenticated' });
  const { user, isAuthenticated } = auth0 || {};
  const { returnTo } = queryString.parse(window.location.search) || {};
  const emailVerified = hasVerifiedEmailClaim(user);

  // if authed and if onRedirectCallback doesn't fire, handle here
  useEffect(() => {
    if (isAuthenticated && emailVerified) {
      const redirectTo =
        returnTo && returnTo !== '/auth-callback' ? (returnTo as string) : '/';
      // Small timeout so Auth0 SDK def had a chance
      const timer = setTimeout(() => {
        navigate({ to: redirectTo, replace: true });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isAuthenticated, emailVerified, returnTo, navigate]);

  // Only render loading page, otherwise should be redirecting
  return <LoadingPage loadingPage />;
};

export const Route = createFileRoute('/_authenticated/auth-callback')({
  component: AuthCallback,
  staticData: {
    accountOptional: true,
  },
});
